import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-restricted',
  standalone: false,
  templateUrl: './restricted.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./restricted.component.scss']
})
export class RestrictedComponent implements OnInit {

  errorText = `Behörigheter saknas för sidan du försökte besöka.`; 
  constructor() { }

  ngOnInit() {
  }

}
